import React from 'react';
import { FormattedMessage } from 'react-intl';

import Styled from 'styled';
import ScrollToTop from 'lib/scroll/scroll-to-top';

import FetchMoreButton from 'four-nets/ui-v2/fetch-more-button/fetch-more-button';

import User from './user/user';
import { UsersListFragment } from './users-list.graphql';
import defaultStyles from './users-list.scss';

export interface Props extends UsersListFragment {
    fetchMore?: (() => Promise<any>) | null;
    styles?: typeof defaultStyles;
}

interface State {
    loading: boolean;
}

class UsersList extends React.PureComponent<Props> {
    state: State = {
        loading: false,
    };

    onFetchMore = () => {
        if (this.props.fetchMore) {
            this.setState({
                loading: true,
            });

            this.props.fetchMore().finally(() => {
                this.setState({
                    loading: false,
                });
            });
        }
    };

    render() {
        const { styles } = this.props;

        return (
            <React.Fragment>
                <ScrollToTop />
                <div className={styles!.scroll}>
                    <table className={styles!.table}>
                        <thead className={styles!.header}>
                            <tr>
                                <th className={styles!.title}>
                                    <FormattedMessage id='LOGIN_NAME_AGE' />
                                </th>
                                <th className={styles!.title}>
                                    <FormattedMessage id='FAVORITED' />
                                </th>
                                <th className={styles!.title}>
                                    <FormattedMessage id='GROUP_ABOUT_POSTS_COUNT' />
                                </th>
                                <th className={styles!.title}>
                                    <FormattedMessage id='LAST_LOGIN' />
                                </th>
                                <th className={styles!.title}>
                                    <FormattedMessage id='DATE_JOINED' />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.edges.map(edge => (
                                <User key={edge!.node!.id} {...edge!.node!} />
                            ))}
                        </tbody>
                    </table>
                </div>
                {this.props.fetchMore ? (
                    <FetchMoreButton
                        disabled={this.state.loading}
                        loading={this.state.loading}
                        onClick={this.onFetchMore}
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

export default Styled(defaultStyles)(UsersList);
